export default __webpack_public_path__ + "static/media/btngoogle.0c464042.png";